'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesYear: {
            type: String,
            kComposite: 'messages.year'
        },
        messagesMonth: {
            type: String,
            kComposite: 'messages.month'
        },
        messagesDay: {
            type: String,
            kComposite: 'messages.day'
        },
        messagesWeekday: {
            type: String,
            kComposite: 'messages.weekday'
        },
        messagesHour: {
            type: String,
            kComposite: 'messages.hour'
        },
        messagesMinute: {
            type: String,
            kComposite: 'messages.minute'
        },
        messagesSecond: {
            type: String,
            kComposite: 'messages.second'
        },
        messagesDayperiod: {
            type: String,
            kComposite: 'messages.dayperiod'
        }
    }
};